import MicroModal from "micromodal";
import { clearErrors } from "../module/errors";

export default function initModals() {
  MicroModal.init({
    openTrigger: "data-micromodal-trigger",
    closeTrigger: "data-micromodal-close",
    disableScroll: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,

    onClose: (modal) => {
      const btnEl = document.getElementById('modal-submit');
      if (btnEl && btnEl.hasAttribute('car_id')) {
        btnEl.removeAttribute('car_id');
      }

      if (btnEl && btnEl.hasAttribute('going')) {
        btnEl.removeAttribute('going');
      }
    },

    onShow: (modal) => {
      clearErrors();
      const formEl = modal.querySelector("form");
      if (formEl) {
        formEl.reset();
      }
    },
  });
}
